import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeftIcon, CalendarIcon, UserIcon } from 'lucide-react';
import { posts } from '../components/Blog';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ScrollToTop } from '../components/ScrollToTop';
export function BlogPost() {
  const {
    slug
  } = useParams<{
    slug: string;
  }>();
  const post = posts.find(p => p.slug === slug);
  if (!post) {
    return <div className="w-full min-h-screen bg-[#1c1c1c] flex items-center justify-center" data-id="element-257">
        <div className="text-center" data-id="element-258">
          <h1 className="text-4xl font-bold text-white mb-4" data-id="element-259">Post Not Found</h1>
          <Link to="/" className="inline-flex items-center gap-2 text-[#d4af37] hover:text-[#4b4bff] transition-colors" data-id="element-260">
            <ArrowLeftIcon className="w-5 h-5" data-id="element-261" />
            Back to Home
          </Link>
        </div>
      </div>;
  }
  return <div className="w-full min-h-screen bg-[#1c1c1c]" data-id="element-262">
      <Header data-id="element-263" />
      <main className="pt-20" data-id="element-264">
        {/* Hero Section */}
        <div className="relative h-[300px] sm:h-[400px] md:h-[500px] overflow-hidden" data-id="element-265">
          <img src={post.image} alt={post.title} className="w-full h-full object-cover" data-id="element-266" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#1c1c1c] to-transparent" data-id="element-267" />
        </div>
        {/* Content */}
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 -mt-20 relative z-10" data-id="element-268">
          <motion.article initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="bg-[#0f0f0f] rounded-lg p-6 sm:p-8 md:p-12 mb-12" data-id="element-269">
            {/* Back Button */}
            <Link to="/" className="inline-flex items-center gap-2 text-[#d4af37] hover:text-[#4b4bff] transition-colors mb-6" data-id="element-270">
              <ArrowLeftIcon className="w-4 h-4" data-id="element-271" />
              Back to Blog
            </Link>
            {/* Title */}
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-272">
              {post.title}
            </h1>
            {/* Meta Info */}
            <div className="flex flex-wrap items-center gap-4 sm:gap-6 text-gray-400 text-sm mb-8 pb-8 border-b border-gray-800" data-id="element-273">
              <div className="flex items-center gap-2" data-id="element-274">
                <CalendarIcon className="w-4 h-4" data-id="element-275" />
                <span data-id="element-276">{post.date}</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-277">
                <UserIcon className="w-4 h-4" data-id="element-278" />
                <span data-id="element-279">{post.author}</span>
              </div>
            </div>
            {/* Content */}
            <div className="prose prose-invert prose-lg max-w-none" dangerouslySetInnerHTML={{
            __html: post.content
          }} style={{
            color: '#d1d5db'
          }} data-id="element-280" />
            {/* CTA */}
            <div className="mt-12 pt-8 border-t border-gray-800" data-id="element-281">
              <div className="bg-[#1c1c1c] rounded-lg p-6 sm:p-8 text-center" data-id="element-282">
                <h3 className="text-2xl font-bold text-white mb-4" data-id="element-283">
                  Ready to Start Your Renovation?
                </h3>
                <p className="text-gray-400 mb-6" data-id="element-284">
                  Contact us today for a free consultation and quote
                </p>
                <Link to="/?section=contact" className="inline-flex items-center gap-2 bg-[#d4af37] text-[#1c1c1c] px-8 py-4 rounded-full text-lg font-semibold hover:bg-[#4b4bff] hover:text-white transition-all duration-300 transform hover:scale-105" data-id="element-285">
                  Get a Free Quote
                </Link>
              </div>
            </div>
          </motion.article>
        </div>
      </main>
      <Footer data-id="element-286" />
      <ScrollToTop data-id="element-287" />
    </div>;
}